import { useTranslations } from 'next-intl';
import { useFormStatus } from 'react-dom';

export function SubmitButton() {
  const { pending } = useFormStatus();
  const t = useTranslations('common');

  return (
    <button
      type="submit"
      aria-disabled={pending}
      className="rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-75 opacity-100 transition-opacity ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
    >
      {pending ? t('submitting') : t('submit')}
    </button>
  );
}
